import { Plus } from "lucide-react";
import { Button } from "~/atoms/button";
import { EventSwatch } from "./EventSwatch";
import { formatDate } from "./helpers";
import { useText } from "./text";
import { type AnnualWheelEvent } from "./types";

interface Props {
  year: number;
  // The events of that year, in the order of their days
  events: AnnualWheelEvent[];
  onAdd: () => void;
  onOpen: (annualWheelEvent: AnnualWheelEvent) => void;
  // The event whose pin should stand out, or none
  onHighlight: (eventId?: number) => void;
}

export const EventList = ({
  year,
  events,
  onAdd,
  onOpen,
  onHighlight,
}: Props) => {
  const text = useText();

  return (
    <section className="flex flex-col gap-2">
      <div>
        <div className="flex items-center justify-between gap-2">
          <h2 className="font-semibold">{text.events.inYear(year)}</h2>
          {/* Beside the tabs on wider screens */}
          <Button
            variant="outline"
            size="sm"
            className="sm:hidden"
            onClick={onAdd}
          >
            <Plus />
            {text.events.add}
          </Button>
        </div>
        <p className="text-muted-foreground">
          {events.length > 0 ? text.events.hint : text.events.none}
        </p>
      </div>
      <ul className="flex flex-wrap gap-2">
        {events.map((annualWheelEvent) => (
          <li key={annualWheelEvent.id}>
            <button
              type="button"
              className="border-border hover:bg-muted focus-visible:ring-ring flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1 text-sm outline-none focus-visible:ring-2"
              onClick={() => onOpen(annualWheelEvent)}
              onPointerEnter={() => onHighlight(annualWheelEvent.id)}
              onPointerLeave={() => onHighlight()}
              onFocus={() => onHighlight(annualWheelEvent.id)}
              onBlur={() => onHighlight()}
            >
              <EventSwatch color={annualWheelEvent.color} />
              {annualWheelEvent.name}
              <span className="text-muted-foreground">
                {formatDate(annualWheelEvent.date, "dayMonth")}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
